export const zIndex = {
  primary: 1000,
  secondary: 1200,
  modal: 1400,
  cookie: 1600,
  negative: -1,
  first: 1,
  second: 2,
};
